import React from 'react'
import styles from '../UIGameBarbarianInvasionTracker.module.scss'
import {T, Tooltip} from '@colonist/ui'
import clsx from 'clsx'
import {type TranslationObject} from '@colonist/i18n'
import IconBarbarianShip from '@static/images/icon_barbarian_ship.svg'

export interface UIGameBarbarianInvasionTrackerShipProps {
    barbarianStrength: number
    className?: string
}

const tooltipContent: TranslationObject[] = [
    {key: 'strings:game.tips.barbarians.body.0'},
    {key: 'strings:game.tips.barbarians.body.1'},
]

export const UIGameBarbarianInvasionTrackerShip = ({
    barbarianStrength,
    className,
}: UIGameBarbarianInvasionTrackerShipProps) => (
    <Tooltip
        className={clsx(styles.iconWrapper, className)}
        content={
            <>
                {tooltipContent.map((item, i) => (
                    <div className={styles.tooltipItem} key={i}><T id={item} /></div>
                ))}
            </>
        }
        delay={0}
        menuClassName={styles.tooltipMenu}
        position="bottom-start"
        title={<T id={{key: 'strings:game.tips.barbarians.title'}} />}
    >
        <img className={styles.icon} src={IconBarbarianShip} />
        <div className={styles.iconBadge}>
            <span>{barbarianStrength}</span>
        </div>
    </Tooltip>
)
